/* istanbul ignore file */
import { ListBreadcrumbItem, TabProps } from 'framework/ui/BreadCrumbs';
import SingleVacancyBreadcrumbs from 'domain/recruiting/newVacancy/shared/SingleVacancyBreadcrumbs';
import { useVacancyGroupUrl } from 'domain/recruiting/newVacancy/routing';
import { useNavigate } from 'react-router-dom';

interface VacancyGroupBreadcrumbsProps {
  children?: any;
  entity?: string;
  tabs?: TabProps[];
}

const VacancyGroupBreadcrumbs = ({ children, entity = 'Vacancy', tabs }: VacancyGroupBreadcrumbsProps) => {
  const { getSingleEntityUrl } = useVacancyGroupUrl();
  const navigate = useNavigate();

  return (
    <SingleVacancyBreadcrumbs onClickCallback={() => navigate(getSingleEntityUrl())}>
      <ListBreadcrumbItem entity={entity} link={`${getSingleEntityUrl()}/publications`} options={tabs} />
      {children}
    </SingleVacancyBreadcrumbs>
  );
};

export default VacancyGroupBreadcrumbs;
